import { Button, makeStyles } from "@material-ui/core";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";

const LS_NAME = 'audioMessageRate';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        minWidth: 280,
        maxWidth: "100%",
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "5px 4px",
        "& audio": {
            height: 38,
            width: "100%",
            maxWidth: 330,
            accentColor: theme.palette.primary.main,
        },
    },
    rate: { minWidth: 38, height: 30, padding: 0, borderRadius: 15, fontSize: ".72rem" },
}));

export default function({url}) {
    const classes = useStyles();
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState( parseFloat(localStorage.getItem(LS_NAME) || "1") );
    const [showButtonRate, setShowButtonRate] = useState(false);

    useEffect(() => {
        audioRef.current.playbackRate = audioRate;
        localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);

    useEffect(() => {
        audioRef.current.onplaying = () => {
            setShowButtonRate(true);
        };
        audioRef.current.onpause = () => {
            setShowButtonRate(false);
        };
        audioRef.current.onended = () => {
            setShowButtonRate(false);
        };
    }, []);

    const toogleRate = () => {
        let newRate = null;

        switch(audioRate) {
            case 0.5:
                newRate = 1;
                break;
            case 1:
                newRate = 1.5;
                break;
            case 1.5:
                newRate = 2;
                break;
            case 2:
                newRate = 0.5;
                break;
            default:
                newRate = 1;
                break;
        }
        
        setAudioRate(newRate);
    };

    return (
        <div className={classes.wrapper}>
            <audio ref={audioRef} controls>
                <source src={url} type="audio/ogg"></source>
            </audio>
            <Button className={classes.rate} variant="outlined" onClick={toogleRate} aria-label="Cambiar velocidad del audio">{audioRate}x</Button>
        </div>
    );
}
